const CONTAINER_ID = 'react-query-devtools';

export function initReactQueryDevTools() {
    const devToolsContainer = document.createElement('div');
    devToolsContainer.id = CONTAINER_ID;
    document.body.append(devToolsContainer);
}

export function toggleReactQueryDevTools(show: boolean) {
    const rqDevTools = document.getElementById(CONTAINER_ID);

    if (!rqDevTools) return;

    rqDevTools.style.display = show ? 'block' : 'none';
}
